/* BrainBash Theme — theme.js */

(function () {
  'use strict';

  // ── Scroll reveal (fade-in + fade-out) ────────────────────────────────────
  // Mark <html> first so CSS can safely hide elements only when JS is active
  document.documentElement.classList.add('bb-js');

  var DIRECTIONS = {
    'bb-hero':     'scale',
    'bb-welcome':  'left',
    'bb-products': 'up',
    'bb-news':     'up',
    'bb-events':   'right',
    'bb-rules':    'up',
    'bb-footer':   'up'
  };

  function getDir(el) {
    for (var key in DIRECTIONS) {
      if (el.classList.contains(key)) return DIRECTIONS[key];
    }
    return 'up';
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.documentElement.classList.remove('bb-js');
      return;
    }

    var secObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { threshold: 0.07 });

    var cardObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-visible', entry.isIntersecting);
      });
    }, { threshold: 0.05 });

    document.querySelectorAll('section, footer').forEach(function (el) {
      el.classList.add('bb-reveal', 'bb-reveal--' + getDir(el));
      secObs.observe(el);
    });

    document.querySelectorAll('.bb-product-card, .bb-article-card, .bb-event-card, .bb-rules__step, .bb-accordion-item').forEach(function (el) {
      el.classList.add('bb-reveal-child');
      cardObs.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }

  // ── Cart count sync ───────────────────────────────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.bb-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      })
      .catch(function () {});
  }

  // ── Smooth anchor scrolling ───────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // ── Video autoplay fallback ───────────────────────────────────────────────
  document.querySelectorAll('video[autoplay]').forEach(function (video) {
    video.play().catch(function () {});
  });

  // ── Expose globally ───────────────────────────────────────────────────────
  window.brainbash = window.brainbash || {};
  window.brainbash.updateCartCount = updateCartCount;

})();
